import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getUserPageAuth } from '../../../utils/page-auth';
import axios from 'axios';
import { Helmet } from 'react-helmet';
import Notification from '../../../components/Notification/Notification';
import config from '../../../config/config';
import ApiClient from '../../../redux/models/src/ApiClient';
import cookies from 'react-cookies';
import useTranslation from '../../../hooks/useTranslation';
import BOTable from '../../../components/Tables/BOTable';
import {
  SELECT_FORM_STYLE,
  STORAGE_TYPE,
} from '../../../constants/base';
import {
  fileListRequest,
  folderListRequest,
} from '../../../redux/actions/app/fileUploadActions';
import useSchemaFileUpload from '../../../schema/table-schema/useSchemaFileUpload';
import ImageModal from '../../../components/modal/imageModal';
import './FileUpload.css';

function FileUpload() {
  const title = '파일 업로드';

  const { t } = useTranslation();
  const { schema } = useSchemaFileUpload(handleImageClick);

  const allowedTypes = [
    'application/x-yaml',
    'text/csv',
    'application/json',
    'image/png',
    'image/jpg',
    'image/jpeg',
    'image/webp',
  ];
  const allowedExt = ['yaml', 'csv', 'json', 'jpg', 'jpeg', 'png', 'webp'];

  const apiURL = config.API_URL;
  const apiClient = new ApiClient();
  const headerData = apiClient.defaultHeaders;
  const accessToken = cookies.load('token');

  // -- useSelector & dispatch --//
  const dispatch = useDispatch();
  const user = useSelector((state) => state.authReducer.user);

  // -- state --//
  const [readOnly, setReadOnly] = useState(true);

  const [notificationMessage, setNotificationMessage] = useState('');
  const [showNotification, setShowNotification] = useState(false);

  const [file, setFile] = useState();
  const [fileName, setFileName] = useState('');

  const [container, setContainer] = useState(2);
  const [folderName, setFolderName] = useState('');
  const [previewUrl, setPreviewUrl] = useState('');
  const [fileType, setFileType] = useState('');

  const [storage, setStorage] = useState(2);

  // 스토리지 - 폴더목록
  const [folderList, setFolderList] = useState([]);

  // BOTable
  const [list, setList] = useState([]);

  // 로딩
  const [isLoading, setIsLoading] = useState(false);

  // 모달에 띄울 이미지
  const [selectedPath, setSelectedPath] = useState('');

  // 모달 열기/닫기
  const [isOpen, setIsOpen] = useState(false);

  // -- func & handler --//
  const fetchList = () => {
    setIsLoading(true);

    dispatch(
      fileListRequest({
        container,
        folderName,
        callback: (data) => {
          console.log("요청 결과: ", data);

          setList(data.list);
          setIsLoading(false);
        },
        error: (error) => {
          console.log(error);
          setNotificationMessage(error.toString());
          setIsLoading(false);
        },
      }),
    );
  };

  const reset = () => {
    // 등록 조건 초기화
    setFileName('');
    setPreviewUrl('');
    document.getElementById('file-input').value = null; // input 창의 파일 명 미리보기까지 초기화
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // 유효성 검토
    if (!file) {
      setNotificationMessage('파일을 선택해 주세요.');
      setShowNotification(true);
      return;
    }

    if (!fileName) {
      setNotificationMessage('파일명을 입력해 주세요.');
      setShowNotification(true);
      return;
    }

    if (folderName) {
      setNotificationMessage('폴더명을 선택해 주세요.');
      setShowNotification(true);
    }

    try {
      const formData = new FormData();

      formData.append('Container', container);
      formData.append('FolderName', folderName);
      formData.append('File', file);
      formData.append('FileName', fileName);

      console.log('FormData');
      for (let [key, value] of formData.entries()) {
        console.log(`${key}:`, value);
      }

      const response = await axios.post(
        `${apiURL}api/System/UploadFile`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            AccessToken: accessToken,
            'CF-Access-Client-Id': headerData['CF-Access-Client-Id'],
            'CF-Access-Client-Secret': headerData['CF-Access-Client-Secret'],
          },
        },
      );

      console.log('Response:', response);
      setNotificationMessage(t('admin.app.upload.config.upload.completed')); // "파일 등록이 완료되었습니다."
      setShowNotification(true);

      // 리스트 갱신
      fetchList();

      // 등록 조건 초기화
      reset();
    } catch (error) {
      console.error('Error:', error);
      setNotificationMessage(error.toString());
      setShowNotification(true);
    }
  };

  function handleImageClick(path) {
    setSelectedPath(path); // 선택된 이미지 경로 설정
    setIsOpen(true); // 모달 열기
  }

  // -- react hooks --//
  useEffect(() => {
    getUserPageAuth(user).then((res) => setReadOnly(res));
  }, [user]);

  useEffect(() => {
    fetchList();
  }, []);

  useEffect(() => {
    getFolderList();
  }, [container]);

  function getFolderList() {
    setIsLoading(true);
    dispatch(
      folderListRequest({
        container: 0,
        callback: (data) => {
          setFolderList(data.list);
          setIsLoading(false);
        },
        error: (e) => {
          console.log(e);
          setNotificationMessage(e.toString());
          setShowNotification(true);
          setIsLoading(false);
        },
      }),
    );
  }

  useEffect(() => {
    fetchList();
  }, [folderName])

  return (
    <div className="page">
      <Helmet>
        <title>{t(title)}</title>
      </Helmet>

      <section className="topSection">
        <div className="leftSection">
          <p className="titleText">{t(title)}</p>
        </div>
      </section>

      <div className="spaceDiv10" />

      <section className="contentsArea">
          <div
            className="descDiv"
            style={{ display: 'flex', justifyContent: 'space-between' }}
          >
            <div className="descDiv">
              <select
                className=""
                value={container ? container : ''}
                onChange={(e) => {
                  setContainer(e.target.value);
                }}
                style={SELECT_FORM_STYLE}
              >
                {/*<option value="" disabled>*/}
                {/*  스토리지*/}
                {/*</option>*/}
                <option value={storage}>스토리지 ({storage})</option>
                {/*{STORAGE_TYPE.map((option) => (*/}
                {/*  <option key={option.key} value={option.key}>*/}
                {/*    {option.value}*/}
                {/*  </option>*/}
                {/*))}*/}
              </select>

              <select
                name=""
                id=""
                style={SELECT_FORM_STYLE}
                onChange={(e) => {
                  setFolderName(e.target.value);
                  reset();
                }}
              >
                <option value="">전체</option>
                {folderList.map((folder) => (
                  <option key={folder} value={folder}>
                    {folder}
                  </option>
                ))}
              </select>

              {/*<button*/}
              {/*  className="defaultBtn"*/}
              {/*  onClick={(e) => {*/}
              {/*    e.preventDefault();*/}
              {/*    fetchList();*/}
              {/*  }}*/}
              {/*>*/}
              {/*  조회*/}
              {/*</button>*/}
              <p className={'notice'}>
                업로드 시 폴더 선택 필수
              </p>
            </div>

            {/* 폴더 선택 안 하면 업로드창 안 보임*/}
            {folderName && (
              <div
                  className={"descDiv"}
                // className="uploadContainer"
                // style={{ display: 'flex', gap: '5px', float: 'right' }}
              >
                <input
                  id="file-input"
                  type="file"
                  onChange={(e) => {
                    const file = e.target.files[0];

                    if (
                      !allowedTypes.includes(file?.type) &&
                      !allowedExt.includes(file?.name.split('.').pop())
                    ) {
                      setNotificationMessage('파일 확장자를 확인해주세요.');
                      setShowNotification(true);
                      return;
                    }

                    setFile(file);

                    file?.type.includes('video')
                      ? setFileType('video')
                      : setFileType('image');

                    if (file && file.size <= 1024 * 1024 * 30) {
                      const reader = new FileReader();

                      console.log('file: ', file);
                      console.log('reader: ', reader);

                      if (file.type.includes('image')) {
                        reader.onloadend = () => {
                          setPreviewUrl(`${reader.result}`);
                        };
                      } else {
                        setPreviewUrl('');
                      }

                      reader.readAsDataURL(file);
                      setFileName(`${file.name}`);

                      return reader;
                    } else {
                      // 파일 용량 초과 시에는 경고 메시지 등을 표시할 수 있습니다.
                      setNotificationMessage(
                        '파일 크기는 30MB 이하여야 합니다.',
                      );
                      setShowNotification(true);
                    }
                  }}
                />
                <input
                  type="text"
                  value={fileName}
                  placeholder="업로드할 파일 이름"
                  onChange={(e) => {
                    setFileName(e.target.value);
                  }}
                />

                <button
                  className="defaultBtn"
                  onClick={handleSubmit}
                  disabled={readOnly}
                >
                  파일 업로드
                </button>
              </div>
            )}
          </div>
      </section>

      <div className="spaceDiv10" />

      {/* 파일 미리보기 */}
      {previewUrl && (
        <div className="preview-container" style={{}}>
          <p>등록할 이미지 미리보기</p>
          <hr style={{ margin: '10px' }} />
          {fileType === 'image' && (
            <img className={'preview-image'} src={previewUrl} alt="preview" />
          )}
          <button
            onClick={() => {
              reset();
            }}
            className={'preview-cancel-btn'}
          >
            취소
          </button>
        </div>
      )}

      <BOTable
        className={'config-upload-table'}
        schema={schema}
        rows={list}
        loading={isLoading}
        onClick={null}
        onImageClick={handleImageClick}
        maxHeight={'calc(100vh - 70px - 50px - 100px)'}
      />

      {/* 이미지 모달 */}
      {isOpen && (
        <ImageModal
          isOpen={isOpen}
          path={selectedPath}
          onClose={() => setIsOpen(false)} // 모달 닫기
        />
      )}

      {showNotification ? (
        <Notification
          close={() => setShowNotification(false)}
          message={notificationMessage}
        />
      ) : null}
    </div>
  );
}

export default FileUpload;
